import React, { useEffect, useState } from 'react'
import TableCustom from '../../../components/table/tableCustom';
import InputTextField from '../../../components/input/inputTextField';
import TableRowCommon from '../../../components/table/TableRowCommon';
import { dateToView } from '../../../utils/date.utils';
import { NavigateFunction, useLocation, useNavigate, useParams } from 'react-router-dom';
import { ButtonBack, ButtonPrimary } from '../../../components/button/ButtonCustoms';
import { Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import OptionsButtonCustom from '../../../components/button/OptionsButtonCustom';
import ModalCustom from '../../../components/modal/ModalCustom';

import { routeName } from '../../../routes/routeName';

import UploadFile from '../../../components/upload/UploadFile';
import { MyCourseOfStudyApi } from '../../../api/my-course-of-study/my-course-of-study.api';
import { useTranslation } from 'react-i18next';

export default function StudentsCourseDetail() {
    const { t } = useTranslation();
    // const currentYear = new Date().getFullYear() + 543; // ค.ศ. -> พ.ศ.
    // const years = Array.from({ length: 5 }, (_, i) => currentYear - i);
    const { id } = useParams();
    const location = useLocation()
    const search_params = new URLSearchParams(location.search);
    const id_course_annual = search_params.get("id_course_annual");
    // i18n-ignore: advisor type names are translated at render site
    const [advisorType, setAdvisorType] = useState<any[]>([{ id_advisor_type: 'LEAD_INSTRUCTOR', advisor_type_name: 'ครูฝึกสอนนำ' }, { id_advisor_type: 'CO_INSTRUCTOR', advisor_type_name: 'ผู้สอนร่วม' }, { id_advisor_type: 'CO_ADVISOR', advisor_type_name: 'ที่ปรึกษาร่วม' }])

    const navigate: NavigateFunction = useNavigate();
    const [detail, setDetail] = useState<any>();
    const [item, setItem] = useState<any>();
    const [data, setData] = useState<any[]>([]);
    const dispatch = useDispatch();

    const [keyword, setKeyword] = useState<string>("");

    const [open, setOpen] = useState<boolean>(false);
    const [study_day, set_study_day] = useState<any>('0');
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    // const loadData = useCallback(async () => {
    //     dispatch(setLoading());

    //     try {
    //         let condition: any = {};
    //         if (page) condition = { ...condition, page: page };
    //         if (pageLimit) condition = { ...condition, limit: pageLimit };

    //         const res = await CourseOfStudyApi.list(condition);
    //         const data = res.data
    //         if (data?.status < 300) {
    //             setData(data?.data?.items);
    //             setPage(data?.data?.meta.currentPage)
    //             setTotalItems(data?.data?.meta?.totalItems)
    //             dispatch(unsetLoading());
    //         } else {
    //             dispatch(unsetLoading());
    //         }
    //     } catch (error) {
    //         dispatch(unsetLoading());
    //     }
    // }, [page, pageLimit,]);

    // useEffect(() => {
    //     fetchGetDegree()
    //     fetchGetFaculty()
    //     fetchGetYears()
    // }, [])
    // useEffect(() => {
    //     loadData();
    // }, [loadData]);

    const getDetail = async () => {
        const res = await MyCourseOfStudyApi.getCourseAnnual(id, id_course_annual);
        const data = res.data;
        if (data.status < 300) {
            console.log(data.data);
            setData(data.data?.course_annual_details)
            setDetail(data.data)
        } else {
            // setForm(null)
        }
    }
    useEffect(() => {
        getDetail()
    }, [])
    const headCells = [
        {
            id: "#",
            width: '500px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("ชื่อ"),
        },
        {
            id: "leave_type_name",
            width: '300px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("วันที่เผยแพร่"),
        },
        {
            id: "leave_type_name",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("เวลาที่เผยแพร่"),
        },
        {
            id: "status",
            disablePadding: false,
            width: '200px',
            sortable: false,
            align: "center",
            label: t("ผู้ที่สร้าง/แก้ไข"),
        },

        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '80px',
            label: "action",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const {
            course_annual_detail_name,
            course_annual_time,
            course_annual_date,
            term,
            id_course_of_study,
            modified_name,
            create_name,
            created_date,
            modified_date
        } = objData;

        const objRenderData = {
            key: id_course_of_study,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "start",
                    label: course_annual_detail_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: dateToView(course_annual_date),
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: course_annual_time,
                },
                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: modified_name || create_name || '-'
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <OptionsButtonCustom
                            enableView

                            onViewClick={() => {
                                setOpen(true)
                                setItem(objData)
                            }}
                        />
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };


    return (
        <div>

            <Typography variant='h3'>
                {t("รหัสวิชา :")} {detail?.courses?.courses_no} / {t("ชื่อรายวิชา :")} {detail?.courses?.courses_name}
            </Typography>
            <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
                {detail?.instructors?.map((item: any, index: number) => {
                    return (
                        <article className="w-full col-span-12 md:col-span-6 lg:col-span-4 sm:col-span-12">
                            <div style={{
                                boxShadow: '0px 0px 8.8px 0px #00000026',
                                padding: '40px',
                                borderRadius: '16px',
                                display: 'flex',
                                gap: '20px'
                            }}>
                                <div style={{
                                    boxShadow: '0px 0px 6px 0px #00000033',
                                    padding: '10px',

                                    borderRadius: '16px',

                                }}>
                                    <img src={item?.file_path ? process.env.REACT_APP_FILE_BASE_API + '/' + item?.file_path : 'https://placehold.co/600x400?text=No-Image'} style={{
                                        width: '148px',
                                        height: '148px', objectFit: 'cover', objectPosition: 'center'
                                    }} />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                    <div>
                                        <Typography variant='h5'>{item?.employee_name}</Typography>
                                        <Typography>{item?.email_organization || '-'}</Typography>
                                        <Typography>{t(advisorType?.find((x: any) => x.id_advisor_type === item?.position_annual)?.advisor_type_name || "")}</Typography>
                                    </div>
                                    <ButtonPrimary
                                        onClick={() => {
                                           !item?.id_advisor_estimate ? navigate(routeName.students.EvaluateTeachers.replace(':id', `${id}`) + `?id_course_annual=${id_course_annual}&id_course_annual_employee=${item?.id_course_annual_employee}${item?.id_advisor_estimate ? `&id_advisor_estimate=${item?.id_advisor_estimate}` : ''}`) : navigate(routeName.students.EvaluateTeachersDetail.replace(':id', `${item?.id_advisor_estimate}`));
                                           
                                        }}
                                        mode="add"
                                        buttonName={t("ประเมินผู้สอน")}
                                        btnProps={{ bg: item?.id_advisor_estimate ? '#00d000' : '#FCAF17', border: item?.id_advisor_estimate ? '#00d000' : '#FCAF17' }}
                                        disabled={
                                            // item?.id_advisor_estimate || 
                                            detail?.course_annual_status !== "CLOSE_CLASS"}
                                    />
                                </div>

                            </div>
                        </article>
                    )
                })}

            </div>

            <section className="w-full mt-10">
                <TableCustom
                    tableMinWidth={1440}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={
                        data.map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>
            <ModalCustom title={item?.course_annual_detail_name} subTitle={t("วันที่เผยแพร่ {{date}} เวลาที่เผยแพร่ {{time}} น.", { date: dateToView(item?.course_annual_date), time: item?.course_annual_time })} open={open} component={
                <div className='flex flex-col gap-4'>
                    <InputTextField
                        value={item?.course_annual_detail_desc || ''}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => { }
                        }
                        heading={t('รายละเอียด')}
                        multiline
                        minRow={6}
                        inputHeight={'auto'}
                        disabled
                    />
                    <section className="my-4">
                        <UploadFile
                            fileAttachmentId={1}
                            fileAttachmentName={item?.file?.course_annual_file_name || ""}
                            // file={item?.file?.course_annual_file_path ? `${item?.file?.course_annual_file_path}` : ""}
                            formatText={''}
                            disableDeleteFileId={true}
                            hiddenDownloadFile={false}

                            onDownloadFile={() => {
                                window.open(process.env.REACT_APP_FILE_BASE_API + '/' + item?.file?.course_annual_file_path + item?.file?.course_annual_file_name, '_blank');
                            }} onDrop={function (data: any): void {
                                throw new Error('Function not implemented.');
                            }} />
                    </section>
                    <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                setOpen(false)
                            }}
                            buttonName={t('ยกเลิก')}
                        />

                    </div>
                </div>
            } />
        </div>

    )
}
